/**
 * 我采购的房屋竞价列表地址
 */
export const HOUSE_AUCTION_PURCHASE_LIST_PAGE_PATH =
  '/auction/house/list/purchase'
